export const SUPPORTED_LANGUAGES = {
  UA: 'ua',
  EN: 'en',
};

export const DEFAULT_LANGUAGE = localStorage.getItem('lang') || 'ua';
